export default "__VITE_ASSET__DA7MLIWj__"